import {
  ContactRound,
  Globe,
  IdCard,
  Trophy,
  UserCheckIcon,
  Users,
} from 'lucide-react';
import React from 'react';
import { Beam } from '../ui/beam';
import { Item, ItemDescription, ItemIcon, ItemTitle } from '../ui/item';

const features = [
  {
    icon: <IdCard className="size-12 stroke-1" />,
    title: 'Personalized Profiles',
    description: 'Build your professional golf identity with custom profiles showcasing your achievements and stats.',
  },
  {
    icon: <Users className="size-12 stroke-1" />,
    title: 'Connect with Golfers',
    description: 'Discover and network with other golfers, influencers, and coaches in the community.',
  },
  {
    icon: <Trophy className="size-12 stroke-1" />,
    title: 'Track Your Progress',
    description: 'Monitor your performance over time and analyze your game to achieve your goals.',
  },
  {
    icon: <Globe className="size-12 stroke-1" />,
    title: 'Golf map',
    description: 'Explore golf courses and connect with players around the world.',
  },
  {
    icon: <UserCheckIcon className="size-12 stroke-1" />,
    title: 'Grow Your Influence',
    description: 'Add custom links to promote your social media, sponsors, or personal brand.',
  },
  {
    icon: <ContactRound className="size-12 stroke-1" />,
    title: 'Share Your Achievements',
    description: 'Showcase your accomplishments with friends, coaches, and potential sponsors.',
  },
];

const Features: React.FC = () => {
  return (
    <div className="relative mx-auto flex animate-moveUp flex-col items-center gap-6 py-16 sm:gap-20">
      <h2 className="max-w-[560px] text-center text-3xl font-semibold leading-tight sm:text-5xl sm:leading-tight">
        Everything you need to elevate your golf journey.
      </h2>
      <div className="relative grid auto-rows-fr grid-cols-1 gap-0 sm:grid-cols-2 sm:gap-4 md:grid-cols-3 md:space-y-3 lg:grid-cols-3">
        {features.map(feature => (
          <Item key={feature.title}>
            <ItemIcon>
              <Beam tone="brand">{feature.icon}</Beam>
            </ItemIcon>
            <ItemTitle className="text-lg">{feature.title}</ItemTitle>
            <ItemDescription>{feature.description}</ItemDescription>
          </Item>
        ))}
      </div>
    </div>
  );
}

export default Features;
